import React from "react";
import { Button } from "@mui/material";
import SwapHorizOutlinedIcon from "@mui/icons-material/SwapHorizOutlined";

import AppModal from "../../Common/AppModal";

const ConfirmCustomerChange = ({ modal, toggle, keep, update }) => {
  return (
    <AppModal
      open={modal}
      onClose={toggle}
      title="Confirm Customer Change Action"
      subtitle="Choose what happens to the existing pricing"
      icon={<SwapHorizOutlinedIcon />}
      headerAccent="indigo"
      size="sm"
      // Three-way choice, so the default Cancel/Save footer doesn't fit.
      footer={
        <>
          <Button color="inherit" onClick={toggle}>
            Cancel
          </Button>
          <Button
            variant="outlined"
            color="success"
            onClick={keep}
            title="Change customer but leave current pricing as is"
          >
            Change &amp; Keep Pricing
          </Button>
          <Button
            variant="contained"
            color="info"
            onClick={update}
            title="Change customer and overwrite their pricing"
          >
            Change &amp; Update Pricing
          </Button>
        </>
      }
    >
      <p className="mb-0 text-muted">
        Changing the customer can either keep the pricing already on this record
        or overwrite it with the new customer&apos;s pricing.
      </p>
    </AppModal>
  );
};

export default ConfirmCustomerChange;
